import { makeAutoObservable, runInAction } from 'mobx'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { showToast, Typography } from 'shared/ui'
import { logger } from 'shared/lib'
import { UsersApi } from 'entities/Users'

const ROLE_UPGRADE_REQUEST_MODAL_ID = 'role_upgrade_request_modal'

export class RoleUpgradeRequestModalStore {
  private _loading = false

  constructor(onCloseCallback?: () => void) {
    makeAutoObservable(this)
    this.openModal(onCloseCallback)
  }

  get loading() {
    return this._loading
  }

  closeModal = () => {
    modalStore.removeModal(ROLE_UPGRADE_REQUEST_MODAL_ID)
  }

  openModal = (onCloseCallback?: () => void) => {
    modalStore.addModal({
      id: ROLE_UPGRADE_REQUEST_MODAL_ID,
      title: 'Request role upgrade',
      desc: (
        <Typography
          variant={'body-lg-regular'}
          ariaLabel={'Request role description'}
          color={'var(--content-primary-primary)'}
        >
          A request will be sent to your organization owner. Once approved, your access will be
          upgraded.
        </Typography>
      ),
      type: ModalTypeList.INFO,
      showCloseButton: false,
      onClose: () => {
        this.closeModal()
        onCloseCallback?.()
      },
      primaryAction: {
        text: 'Send request',
        onAction: async () => {
          await this.updateChangeRoleRequest()
          this.closeModal()
          onCloseCallback?.()
        },
      },
      secondaryAction: {
        text: 'Cancel',
        onAction: () => {
          this.closeModal()
          onCloseCallback?.()
        },
      },
    })
  }

  updateChangeRoleRequest = async () => {
    try {
      runInAction(() => {
        this._loading = true
      })

      await UsersApi.updateChangeRoleRequest()

      showToast({
        type: 'success',
        title: 'Role upgrade request sent',
      })
    } catch (e) {
      logger.error(e)

      showToast({
        type: 'error',
        title: 'Something went wrong. Please try again',
      })
    } finally {
      runInAction(() => {
        this._loading = false
      })
    }
  }
}
